import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const legalLinks = [
  { to: "/privacy", label: "Privacy Policy", id: "privacy" },
  { to: "/terms", label: "Terms of Service", id: "terms" },
  { to: "/cookies", label: "Cookie Notice", id: "cookies" },
  { to: "/support", label: "Support", id: "support" },
];

const isActive = (pathname, to) => pathname === to || (to === "/privacy" && pathname === "/privacy-policy");

const LegalDropdown = ({ pathname }) => {
  const navigate = useNavigate();
  const onLegal = legalLinks.some((l) => isActive(pathname, l.to));
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="nav-legal-dropdown"
        aria-label="Open menu"
        className={`grid h-11 w-11 place-items-center rounded-xl border border-gray-200 outline-none transition-colors data-[state=open]:bg-brand-soft data-[state=open]:text-brand ${onLegal ? "text-brand" : "text-ink"} hover:bg-surface2`}
      >
        <Menu className="h-5 w-5" strokeWidth={2} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={10} className="w-52 rounded-xl border-gray-200 p-1.5 shadow-[0_20px_60px_rgba(37,49,168,0.12)]" data-testid="nav-legal-menu">
        {legalLinks.map((l) => (
          <DropdownMenuItem
            key={l.id}
            onSelect={() => navigate(l.to)}
            data-testid={`nav-link-${l.id}`}
            className={`cursor-pointer rounded-lg px-3 py-2 text-[15px] font-semibold focus:bg-brand-soft focus:text-brand ${isActive(pathname, l.to) ? "text-brand" : "text-ink-2"}`}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const Header = () => {
  const { pathname } = useLocation();
  return (
    <header className="print:hidden sticky top-0 z-30 border-b border-gray-200 bg-white/90 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto max-w-[1100px] px-6 min-h-[68px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="header-logo-link">
          <img src="/emergo-logo.jpg" alt="Emergo logo" className="h-9 w-9 object-contain" data-testid="header-logo" />
          <span className="text-[22px] font-extrabold tracking-[0.02em] text-ink">EMER<span className="text-brand">GO</span></span>
        </Link>
        <nav className="flex items-center" aria-label="Primary" data-testid="header-nav">
          <LegalDropdown pathname={pathname} />
        </nav>
      </div>
    </header>
  );
};
